import { jsonToQuery } from "../utils";
import callApi from "../utils/callApi";
import { ServiceUrl } from "../utils/serviceUrl";

export const _SAVE_AGENCIES = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.AGENCIES.SAVE;
  return callApi(url, "post", searchData && searchData);
};

export const _LIST_AGENCIES = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.AGENCIES.LIST;
  if (searchData) url += "?" + jsonToQuery(searchData);
  return callApi(url);
};

export const _UPDATE_STATUS = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.AGENCIES.STATUS_UPDATE;
  return callApi(url, "post", searchData && searchData);
};

export const _DELETE_AGENCY = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.AGENCIES.DELETE;
  return callApi(url, "post", searchData && searchData);
};

export const _UPDATE_AGENCY = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.AGENCIES.UPDATE;
  return callApi(url, "post", searchData && searchData);
};

export const _UPDATE_PARTNER_BANK = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.AGENCIES.UPDATE_BANK;
  return callApi(url, "post", searchData && searchData);
};

export const _UPDATE_PARTNER_SMSMAIL = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.AGENCIES.UPDATE_SMSMAIL;
  return callApi(url, "post", searchData && searchData);
};

export const _UPDATE_WHITE_LABEL = async (searchData = false) => {
  let url = ServiceUrl.SETTINGS.AGENCIES.UPDATE_WHITE_LABEL;
  return callApi(url, "post", searchData && searchData);
};

export const _ListState = async (serachData = false) => {
  let url = ServiceUrl.SETTINGS.AGENCIES.STATE_LIST;
  if (serachData) url += "?" + jsonToQuery(serachData);
  return callApi(url);
};
